import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Box, Alert, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { VendorTimeline as VendorTimelineComponent } from '../components/VendorTimeline';
import VendorBottomNavigation from '../components/VendorBottomNavigation';

const VendorTimeline: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [vendorId, setVendorId] = useState<number | null>(null);

  useEffect(() => {
    // Check authentication and role
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    // Check if user is a vendor/admin
    const roles = (user as any)?.roles || [];
    const isVendor = roles.some((role: any) => 
      role.name === 'ROLE_VENDOR' || role === 'ROLE_VENDOR' ||
      role.name === 'ROLE_ADMIN' || role === 'ROLE_ADMIN'
    );

    if (!isVendor) {
      navigate('/login');
      return;
    }

    // Get vendor ID from user object
    const userId = (user as any)?.id;
    if (userId) {
      // For vendor users, their user ID is the vendor ID
      setVendorId(Number(userId));
    }

    setLoading(false);
  }, [user, isAuthenticated, navigate]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!vendorId) {
    return (
      <Container>
        <Box mt={4}>
          <Alert severity="error">
            Unable to determine vendor. Please contact your administrator.
          </Alert>
        </Box>
      </Container>
    );
  }

  return (
    <Box sx={{ pb: 10 }}>
      <Container maxWidth="lg" sx={{ mt: 2 }}>
        <VendorTimelineComponent vendorId={vendorId} />
      </Container>
      <VendorBottomNavigation />
    </Box>
  );
};

export default VendorTimeline;